var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x37_20-_menu__x2C__ui__x2C__user_interface__x2C_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 36.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 105.643,
    y2: 105.643
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 36.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 256.511,
    y2: 256.511
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 36.4167,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.6131
    },
    x1: 26.7,
    x2: 486.25,
    y1: 407.312,
    y2: 407.312
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.030341f3e781fc738589947433353e36.svg";
export { ForwardRef as ReactComponent };